import * as z from "zod/v4";

const BrandIdentityGuideSchema_ = z.object({
  id: z.string(),
  companyName: z.string(),
  website: z.string(),
  headquarters: z.string(),
  foundedYear: z.string(),
  industry: z.string(),
  companyDescription: z.string(),
  brandVoice: z.string(),
  missionStatement: z.string(),
  contentStrategy: z.string(),
  marketPosition: z.string(),
  competitiveDifferentiation: z.string(),
  coreValues: z.array(z.string()),
  targetAudience: z.string(),
  brandKeywords: z.string(),
});

export const BrandIdentityGuideSchema: z.ZodType<BrandIdentityGuideSchema> =
  BrandIdentityGuideSchema_;
export interface BrandIdentityGuideSchema
  extends z.infer<typeof BrandIdentityGuideSchema_> {}

export const getBrandIdentityGuide = {
  name: "getBrandIdentityGuide" as const,
  input: z.object({}),
  output: BrandIdentityGuideSchema.nullable(),
};
